import React, { FunctionComponent } from "react";
import { NamedProperty } from "sprint-common-web";

import { MovieContentSubtype } from "../../../../../common/types/MovieContentSubtype";
import { VersionSummary } from "../../../../../common/types/VersionSummary";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { MovieDetailsPageBreadcrumbs } from "../../../common/header/movie/MovieDetailsPageBreadcrumbs";
import { CloudAssetDetailsPageHeaderActions } from "../CloudAssetDetailsPageHeaderActions";

interface MovieDetailsPageHeaderProps {
    contentType: MovieContentSubtype;
    movie: NamedProperty;
    version: VersionSummary;
    deliveryFileName: string;
    filePath: string;
    cloudFileId: string;
    cloudAssetId: string;
    hideActions?: boolean;
}

export const CloudMovieDetailsPageHeader: FunctionComponent<MovieDetailsPageHeaderProps> = (
    props: MovieDetailsPageHeaderProps
) => {
    const { contentType, movie, version, deliveryFileName, filePath, cloudFileId, cloudAssetId, hideActions } = props;

    return (
        <PageHeader>
            <MovieDetailsPageBreadcrumbs contentType={contentType} movie={movie} version={version} />
            <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
                {!hideActions && (
                    <CloudAssetDetailsPageHeaderActions
                        cloudFileId={cloudFileId}
                        deliveryFileName={deliveryFileName}
                        filePath={filePath}
                        cloudAssetId={cloudAssetId}
                    />
                )}
            </AuthorizationWrapper>
        </PageHeader>
    );
};
